<mat-accordion>
  <mat-expansion-panel (closed)="panelOpenState = false" (opened)="panelOpenState = true">
    <mat-expansion-panel-header>
      <mat-panel-title>Maggiori Sconti</mat-panel-title>
      <mat-panel-description>
        Elenco dei maggiori sconti applicati alla pratica.
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div *ngIf="loadingBigBuyers" class="flex items-center justify-center p-8">
      <div class="text-center">
        <mat-spinner diameter="40" class="mx-auto mb-4"></mat-spinner>
        <p class="text-slate-300 text-sm">Caricamento dati...</p>
      </div>
    </div>
    <div
      *ngIf="!loadingBigBuyers && bigBuyersData.length === 0"
      class="flex flex-col items-center justify-center p-8"
    >
      <div class="bg-slate-700/50 rounded-lg p-6 max-w-md w-full text-center">
        <fa-icon [icon]="faInbox" class="text-4xl text-slate-400 mb-4"></fa-icon>
        <p class="text-slate-300 text-base font-medium">Nessun dato disponibile</p>
        <p class="text-slate-400 text-sm mt-2">
          Non sono presenti maggiori sconti per questa pratica.
        </p>
      </div>
    </div>
    <app-table-group-rows
      *ngIf="!loadingBigBuyers && bigBuyersData.length > 0"
      [columns]="columnsBigBuyers"
      [data]="bigBuyersData"
      [showSumCounter]="false"
    ></app-table-group-rows>
  </mat-expansion-panel>
  <mat-expansion-panel (closed)="panelOpenState = false" (opened)="panelOpenState = true">
    <mat-expansion-panel-header>
      <mat-panel-title>Azioni Promozionali</mat-panel-title>
      <mat-panel-description>
        Elenco delle azioni promozionali associate alla pratica.
      </mat-panel-description>
    </mat-expansion-panel-header>
    <div *ngIf="loadingPromotionalActions" class="flex items-center justify-center p-8">
      <div class="text-center">
        <mat-spinner diameter="40" class="mx-auto mb-4"></mat-spinner>
        <p class="text-slate-300 text-sm">Caricamento dati...</p>
      </div>
    </div>
    <div
      *ngIf="!loadingPromotionalActions && promotionalActionsData.length === 0"
      class="flex flex-col items-center justify-center p-8"
    >
      <div class="bg-slate-700/50 rounded-lg p-6 max-w-md w-full text-center">
        <fa-icon [icon]="faInbox" class="text-4xl text-slate-400 mb-4"></fa-icon>
        <p class="text-slate-300 text-base font-medium">Nessun dato disponibile</p>
        <p class="text-slate-400 text-sm mt-2">
          Non sono presenti azioni promozionali per questa pratica.
        </p>
      </div>
    </div>
    <app-table-group-rows
      *ngIf="!loadingPromotionalActions && promotionalActionsData.length > 0"
      [columns]="columnsPromotionalActions"
      [data]="promotionalActionsData"
      [showSumCounter]="false"
    ></app-table-group-rows>
  </mat-expansion-panel>
</mat-accordion>
